import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import KpiDashboard from '../../kpi/KpiDashboard';//eslint-disable-line import/no-named-as-default
import * as dialogActions from '../../../../actions/dialogPopupActions';
import * as trackingDataActions from '../../../../actions/trackingDataActions';
import * as appHelper from '../../../../helpers/appHelper';
import * as kpiHelper from '../../../../helpers/kpiHelper';
import * as objectConstants from '../../../../constants/objectConstants';
import * as kpiConstants from '../../../../constants/kpiConstants';
import * as keyboardConstants from '../../../../constants/keyboardConstants';
import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';

class MultipleAnswerOptionReview extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            option: this.props.option,
            optionRendered: false,
            optionFeedbackRendered: false,
            checkForFeedbackRendered: true,
            locale: {},
            responseData: this.props.responseData,
            feedbackOption: {},
            feedbackOptionLocale: {},
            kpiDashboardParams: {
                responseReview: true,
                showTitle: false,
                showImmediateImpact: true,
                allowUpdates: false
            }
        };
        this.getLocale = this.getLocale.bind(this);
        this.hideOption = this.hideOption.bind(this);
        this.showOption = this.showOption.bind(this);
        this.onOptionRendered = this.onOptionRendered.bind(this);
        this.removeOption = this.removeOption.bind(this);
        this.onOptionHidden = this.onOptionHidden.bind(this);
        this.getDisabledState = this.getDisabledState.bind(this);
        this.getCheckedState = this.getCheckedState.bind(this);
        this.getOptionClass = this.getOptionClass.bind(this);
        this.getClickFunction = this.getClickFunction.bind(this);
        this.checkRenderOptionFeedback = this.checkRenderOptionFeedback.bind(this);
        this.showOptionFeedback = this.showOptionFeedback.bind(this);
        this.hideOptionFeedback = this.hideOptionFeedback.bind(this);
        this.showOptionFeedbackComplete = this.showOptionFeedbackComplete.bind(this);
        this.getShowKpis = this.getShowKpis.bind(this);
        this.getShowFeedback = this.getShowFeedback.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);
        this.onObjectSelected = this.onObjectSelected.bind(this);
    }

    componentDidMount() {
        this.getLocale();
        this.showOption(1, (this.props.index / 4));

    }

    componentWillReceiveProps(nextProps) {
        if (this.state.responseData !== nextProps.responseData) {
            this.setState({responseData: nextProps.responseData});
        }
        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.option),
                feedbackOption: appHelper.isDefined(this.state.option.feedback_id) ? Object.assign({}, appHelper.getArrayObjectByKey(this.props.options, "option_id", this.state.option.option_id)) : Object.assign({}, appHelper.getArrayObjectByKey(this.props.options, "option_id", this.state.option.feedback_id))
            });
        }
    }

    componentDidUpdate() {
        let checkedIndex = appHelper.getArrayObjectIndexByKey(this.state.responseData.checkedOptions, "option_id", this.state.option.option_id);
        if (checkedIndex > -1 && this.state.checkForFeedbackRendered) {
            this.checkRenderOptionFeedback();
        } else if (checkedIndex === -1 && this.state.optionFeedbackRendered) {
            this.hideOptionFeedback();
        }
    }

    getLocale() {
        let locale = appHelper.getLocalData(this.state.option);
        let feedbackOption = {};
        if (!appHelper.isDefined(this.state.option.feedback_id)) {
            feedbackOption = Object.assign({}, appHelper.getArrayObjectByKey(this.props.options, "option_id", this.state.option.option_id));
        } else {
            feedbackOption = Object.assign({}, appHelper.getArrayObjectByKey(this.props.options, "option_id", this.state.option.feedback_id));
        }

        this.setState(
            {
                locale: Object.assign({}, locale),
                feedbackOption: Object.assign({}, feedbackOption),
                feedbackOptionLocale: appHelper.getLocalData(feedbackOption)
            }
        );
    }

    checkRenderOptionFeedback() {
        let checkedIndex = appHelper.getArrayObjectIndexByKey(this.state.responseData.checkedOptions, "option_id", this.state.option.option_id);
        if (checkedIndex > -1 && this.state.checkForFeedbackRendered) {
            if (this.state.optionRendered) {
                this.showOptionFeedback();
            }
        } else {
            this.setState({optionFeedbackRendered: false});
        }

    }

    showOptionFeedback() {
        let feedbackPanel = this.refs[`${this.state.feedbackOption.option_id}_feedBackPanel`];
        if (appHelper.isDefined(feedbackPanel)) {
            TweenLite.set(feedbackPanel, {height: "auto", opacity: 1});
            TweenLite.from(feedbackPanel, 0.2, {
                height: 0,
                opacity: 0,
                ease: Expo.easeInOut
            }).eventCallback("onComplete", this.showOptionFeedbackComplete);
        }
    }

    showOptionFeedbackComplete() {
        this.setState({optionFeedbackRendered: true, checkForFeedbackRendered: false});
    }

    hideOptionFeedback() {
        this.setState({optionFeedbackRendered: false, checkForFeedbackRendered: true});
    }


    getOptionClass() {
        let checkedIndex = appHelper.getArrayObjectIndexByKey(this.state.responseData.checkedOptions, "option_id", this.state.option.option_id);
        let answerIndex = appHelper.getArrayObjectIndexByKey(this.props.responseData.userSelections, "option_id", this.state.option.option_id);
        if (appHelper.isDefined(this.state.responseData.outcome.result) && answerIndex > -1) {
            if (checkedIndex > -1 && appHelper.isDefined(this.state.feedbackOption.option_id) && ((appHelper.isDefined(this.state.feedbackOptionLocale.feedback) && this.state.feedbackOptionLocale.feedback.length > 0) || this.state.option.kpis !== null)) {
                return `review-selected review-current ${this.state.option.result}`;
            } else {
                return `review-selected ${this.state.option.result}`;
            }
        } else {
            if (checkedIndex > -1 && appHelper.isDefined(this.state.feedbackOption.option_id)) {
                return `review review-current ${this.state.option.result}`;
            } else {
                return `review ${this.state.option.result}`;
            }
        }

    }

    getShowKpis() {
        let answerIndex = appHelper.getArrayObjectIndexByKey(this.props.responseData.userSelections, "option_id", this.state.option.option_id);
        return appHelper.isDefined(this.state.responseData.outcome.result) && answerIndex > -1;
    }

    getClickFunction() {
        let responseData = this.state.responseData;
        let latestResponse = appHelper.getLastItemOfArray(responseData.responses);
        if ((responseData.currentAttempt === responseData.responses.length) && (latestResponse.selectedOption.option_id == this.state.option.option_id)) {
            if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_ANSWERED) {
                this.props.onReviewObject();
            }
        }
    }

    getDisabledState() {
        /*if(!appHelper.isDefined(this.state.feedbackOption.option_id)){
            return "disabled";
        }*/
        return null;
    }

    getCheckedState() {
        let checkedIndex = appHelper.getArrayObjectIndexByKey(this.state.responseData.checkedOptions, "option_id", this.state.option.option_id);
        if (appHelper.isDefined(this.state.responseData.outcome.result) && checkedIndex > -1) {
            return `checked`;
        }
        return null;
    }

    hideOption() {
        let optionRef = this.refs[this.state.option.option_id];
        TweenLite.to(optionRef, objectConstants.MC_OPTION_DURATION, {
            opacity: 0,
            delay: 0.5,
            ease: Expo.easeOut
        }).eventCallback("onComplete", this.scaleOptionHeight);
    }

    showOption(duration, delay) {
        let optionRef = this.refs[this.state.option.option_id];
        TweenLite.set(optionRef, {height: "auto", opacity: 1});
        TweenLite.from(optionRef, objectConstants.MC_OPTION_DURATION, {
            height: 0,
            opacity: 0,
            delay: delay,
            ease: Expo.easeInOut
        }).eventCallback("onComplete", this.onOptionRendered);
    }

    onOptionRendered() {
        let checkedIndex = appHelper.getArrayObjectIndexByKey(this.state.responseData.checkedOptions, "option_id", this.state.option.option_id);
        this.setState({
            optionRendered: true,
            optionFeedbackRendered: checkedIndex > -1,
            checkForFeedbackRendered: checkedIndex === -1
        });
    }

    onOptionHidden() {
        let responseData = this.state.responseData;
        let latestResponse = appHelper.getLastItemOfArray(responseData.responses);

        //if selected option is first in the list
        if (latestResponse.index === 0) {
            this.removeOption();
        } else {
            this.scaleOptionHeight();
        }
    }
    
    removeOption() {
        //this.setState({render: false});
    }

    getShowFeedback() {
        let optionIndex = appHelper.getArrayObjectIndexByKey(this.state.responseData.checkedOptions, "option_id", this.state.option.option_id);
        return optionIndex > -1 && ((appHelper.isDefined(this.state.feedbackOptionLocale.feedback) && this.state.feedbackOptionLocale.feedback.length > 0) || (this.state.option.kpis !== null && kpiHelper.kpisAreVisible(this.state.option.kpis, this.state.responseData.bite_id)));
    }

    onObjectSelected() {
        this.props.onOptionClick(this.state.option);
    }

    setKeyboardAccessibility(event) {
        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            this.onObjectSelected();
        }

        if (event.which === keyboardConstants.ARROW_UP_KEY) {
            event.preventDefault();
            let optionIndex = appHelper.getArrayObjectIndexByKey(this.props.options, "option_id", this.state.option.option_id);
            let nextIndex = optionIndex - 1;

            if (optionIndex === 0) {
                nextIndex = this.props.options.length - 1;
            }
            let nextItem = Object.assign({}, this.props.options[nextIndex]);
            let focusItem = document.getElementById(`review_option_${nextItem.option_id}`);
            focusItem.focus();
        }

        if (event.which === keyboardConstants.ARROW_DOWN_KEY) {
            event.preventDefault();
            let optionIndex = appHelper.getArrayObjectIndexByKey(this.props.options, "option_id", this.state.option.option_id);
            let nextIndex = optionIndex + 1;
            if (optionIndex === (this.props.options.length - 1)) {
                nextIndex = 0;
            }

            let nextItem = Object.assign({}, this.props.options[nextIndex]);
            let focusItem = document.getElementById(`review_option_${nextItem.option_id}`);
            focusItem.focus();
        }
    }

    render() {

        return (

            <div className={`multiple-choice-option ${this.getOptionClass()}`}
                 ref={this.state.option.option_id}
                 id={`review_option_${this.state.option.option_id}`}
                 role="button" tabIndex={0}

                 onKeyDown={this.setKeyboardAccessibility}
                 aria-controls={`review_feedback_wrapper_${this.state.option.option_id}`}
                 aria-expanded={appHelper.getArrayObjectIndexByKey(this.state.responseData.checkedOptions, "option_id", this.state.option.option_id) > -1}>
                <input id={`${this.props.asset_id}_${this.state.option.option_id}_review`} type="radio"
                       name={`${this.props.asset_id}_${this.state.option.option_id}_review`}
                       tabIndex="-1"
                       aria-hidden="true" aria-disabled="true"
                       value={this.state.option.option_id} onClick={this.onObjectSelected}/>

                <label htmlFor={`${this.props.asset_id}_${this.state.option.option_id}_review`}>
                    <span dangerouslySetInnerHTML={{__html: this.state.locale.option}}/>
					<span className="hidden-el">{appHelper.getOptionResultString(this.state.option.result,false)}</span>
                </label>

                {this.getShowFeedback()
                    ?
                    <div ref={`${this.state.feedbackOption.option_id}_feedBackPanel`}
                         className={`feedback-panel ${this.state.option.result} object-container`}>
                        {
                            appHelper.isDefined(this.state.option.kpis) && this.state.option.kpis !== null && this.state.option.kpis.length > 0
                                ?
                                <KpiDashboard
                                    displayState={kpiConstants.KPI_DISPLAY_STATE_REVIEW_POINTS_AWARDED}
                                    bite_id={this.props.responseData.bite_id}
                                    screen_id={this.props.responseData.screen_id}
                                    object_id={this.props.responseData.asset_id}
                                    option={this.state.option}
                                    responseReview={this.state.kpiDashboardParams.responseReview}
                                    showImmediateImpact={this.state.kpiDashboardParams.showImmediate}
                                    showTitle={this.state.kpiDashboardParams.showTitle}/>
                                :
                                null
                        }
                        {
                            appHelper.isDefined(this.state.feedbackOptionLocale) &&  appHelper.isDefined(this.state.feedbackOptionLocale.feedback) && this.state.feedbackOptionLocale.feedback.length > 0
                                ?
                                <div
                                    dangerouslySetInnerHTML={{__html: this.state.feedbackOptionLocale.feedback}}/>
                                :
                                null
                        }

                    </div>
                    :
                    null
                }
            </div>


        );

    }
}

/* */

MultipleAnswerOptionReview.propTypes = {
    option: PropTypes.object.isRequired,
    asset_id: PropTypes.number.isRequired,
    questionChecked: PropTypes.bool.isRequired,
    responseData: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired,
    options: PropTypes.array.isRequired,
    onOptionClick: PropTypes.func,
    onAttemptComplete: PropTypes.func,
    onReviewObject: PropTypes.func,
    contentData: PropTypes.object,
    trackingData: PropTypes.object,
    lang: PropTypes.string,//.isRequired,
    actions: PropTypes.object
};

MultipleAnswerOptionReview.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(ownProps,state) {
    return {
        lang:appHelper.isDefined(state.userData) ? state.userData.lang : localStorage.default_langauge,
        contentData: state.contentData,
        trackingData: state.trackingData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, trackingDataActions, dialogActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(MultipleAnswerOptionReview);



/** WEBPACK FOOTER **
 ** ./src/components/objects/multipleChoice/multipleAnswer/MultipleAnswerOptionReview.js
 **/